const US_T: {
    phoneTitle: string;
    emailText: string;
    emailTitle?: string;
    chatTitle?: string;
    chatText?: string;
    chatDesc?: string;
    communityTitle: string;
    communityDesc: string;
    moduleTitle: string;

    successCopy: string;
    errorCopy: string;
} = {
    moduleTitle: 'Contact us',
    phoneTitle: 'Customer Service Helpline',
    emailTitle: 'Email',
    emailText: 'Email Us',
    chatTitle: "Let's Chat",
    chatText: 'Please contact us via Live Chat ',
    chatDesc: 'Online 24 hours',
    communityTitle: 'EcoFlow Community',
    communityDesc: 'Discover our community and connect with EcoFlow users all over the world!',

    successCopy: 'Successfully copied to clipboard!',
    errorCopy: 'Failed to copy to clipboard!',
};
export const G_DATA: {
    [key: string]: {
        phone?: string;
        serviceTime?: string;
        email?: string;

        // 国际化相关
        moduleTitle: string;
        phoneTitle: string;
        emailTitle?: string;
        emailText: string;
        chatTitle?: string;
        chatText?: string;
        chatDesc?: string;
        communityTitle: string;
        communityDesc: string;

        successCopy: string;
        errorCopy: string;
    };
} = {
    us: {
        phone: '+1(800)-368-8604',
        serviceTime: 'Mon-Fri 9am-7pm',
        email: 'support@ecoflow.com',

        ...US_T,
    },
    ca: {
        phone: '+1(800)-368-8604',
        serviceTime: 'Mon-Fri 9am-7pm',
        email: 'support@ecoflow.com',

        ...US_T,
    },
    uk: {
        phone: '8088126006',
        serviceTime: 'Mon-Fri 8 am-4 pm (BST) ',
        email: 'support.eu@ecoflow.com',

        ...US_T,
    },
    au: {
        phone: '61 1800 610 248',
        serviceTime: 'Monday to Friday, 9:00 AM - 12:00 PM and 1:00 PM - 5:00 PM (GMT+10)',
        email: 'support.au@ecoflow.com',

        ...US_T,
    },
    za: {
        phone: '27 80 088 0002',
        serviceTime: 'Monday to Friday 8:30-17:00 GMT+2',
        email: 'support.za@ecoflow.com',

        ...US_T,
    },
    eu: {
        phone: '800018036',
        serviceTime: 'Mon-Fri 9 am-5 pm (CET) ',
        email: 'support.eu@ecoflow.com',

        ...US_T,
    },
    de: {
        phone: '08000002566',
        serviceTime: 'Mon-Fri 9 am-5 pm (CET)',
        email: 'support.eu@ecoflow.com ',

        moduleTitle: 'Kontaktieren Sie uns',
        phoneTitle: 'Kundenservice-Hotline',
        emailText: 'Schreiben Sie uns eine E-Mail',
        communityTitle: 'EcoFlow Community',
        communityDesc: 'Entdecken Sie unsere Community und treten Sie mit EcoFlow Nutzern auf der ganzen Welt in Kontakt!',

        successCopy: 'Erfolgreich in die Zwischenablage kopiert!',
        errorCopy: 'Kopieren in die Zwischenablage fehlgeschlagen!',

        chatTitle: 'Lass uns chatten',
        chatText: 'Bitte kontaktieren Sie uns über den Live-Chat',
        chatDesc: 'Online 24 Stunden',
    },
    fr: {
        phone: '(+44) 800 028 7166',
        serviceTime: 'Mon-Fri 9 am-5 pm (CET)',
        email: 'support.eu@ecoflow.com',

        moduleTitle: 'Contactez-nous',
        phoneTitle: 'Assistance téléphonique',
        emailText: 'Envoyez-nous un e-mail',
        communityDesc: "Rejoignez notre communauté et connectez-vous avec des utilisateurs d'EcoFlow du monde entier !",
        communityTitle: 'Communauté EcoFlow',

        successCopy: 'Copié avec succès dans le presse-papiers !',
        errorCopy: 'Impossible de copier dans le presse-papiers !',

        chatTitle: 'Discutons',
        chatText: 'Veuillez nous contacter via le chat en direct',
        chatDesc: 'En ligne 24 heures',
    },
    it: {
        email: 'support.eu@ecoflow.com ',

        moduleTitle: 'Contattaci',
        phoneTitle: 'Linea diretta del servizio clienti',
        emailText: 'Inviaci un’e-mail',
        communityTitle: 'Community EcoFlow',
        communityDesc: 'Scopri la nostra community ed entra in contatto con utenti EcoFlow di ogni parte del mondo!',

        successCopy: 'Copiato con successo negli appunti!',
        errorCopy: 'Impossibile copiare negli appunti!',

        chatTitle: 'Chatta con noi',
        chatText: 'Contattaci tramite la Chat dal vivo',
        chatDesc: 'Online 24 ore su 24',
    },
    es: {
        email: 'support.eu@ecoflow.com ',

        moduleTitle: 'Contáctanos',
        phoneTitle: 'Línea de atención al cliente',
        emailText: 'Envíanos un correo electrónico',
        communityTitle: 'Comunidad de EcoFlow',
        communityDesc: '¡Descubre nuestra comunidad y conéctate con usuarios de EcoFlow de todo el mundo!',

        successCopy: '¡Copiado con éxito al portapapeles!',
        errorCopy: ' ¡No se pudo copiar al portapapeles!',

        chatTitle: 'Hablemos',
        chatText: 'Por favor, contáctanos por Chat en vivo',
        chatDesc: 'En línea 24 horas',
    },
    cn: {
        phone: '400-600-5753',
        serviceTime: '工作日9:00-12:00 14:00-18:00',

        moduleTitle: '联系我们',
        phoneTitle: '热线服务',
        emailTitle: '邮箱',
        emailText: '给我们发电子邮件',
        communityTitle: 'EcoFlow社区',
        communityDesc: '发现社区的力量并与全球 EcoFlow 用户建立联系！',

        successCopy: '已成功复制到剪贴板！',
        errorCopy: '无法复制到剪贴板',

        chatTitle: '在线聊天',
        chatText: '请通过在线聊天与我们联系',
        chatDesc: '24小时在线',
    },
    tw: {
        email: 'support.sea@ecoflow.com',

        moduleTitle: '洽詢管道',
        phoneTitle: '客服專線',
        emailTitle: '邮箱',
        emailText: '傳送電子郵件',
        communityTitle: 'EcoFlow 社群',
        communityDesc: '發現我們的社群並與全世界的 EcoFlow 用戶交流互動！',

        successCopy: '已成功複製到剪貼簿！',
        errorCopy: '無法複製到剪貼簿！',
    },
    jp: {
        phone: '050-3090-2966',
        serviceTime: '10:00~19:00（土日祝日を除く）',
        email: 'support.jp@ecoflow.com',

        moduleTitle: 'お問い合わせ',
        phoneTitle: 'お電話',
        emailText: '電子メール',
        communityTitle: 'EcoFlow コミュニティ',
        communityDesc: 'EcoFlow のコミュニティを発見し、世界中のユーザーとつながりましょう！',

        successCopy: 'クリップボードに正常にコピーされました！',
        errorCopy: 'クリップボードにコピーできませんでした！',

        chatTitle: 'チャットをはじめましょう',
        chatText: 'ライブチャットにてお問い合わせください',
        chatDesc: '24時間オンライン',
    },
    kr: {
        phone: '15444961',
        serviceTime: '평일 10:00~13:00,14:00-19:00 (토, 일요일 및 공휴일 휴무)',
        email: 'support.kr@ecoflow.com',

        moduleTitle: '문의하기',
        phoneTitle: '고객 서비스 핫라인',
        emailText: '이메일 보내기',
        communityTitle: 'EcoFlow 커뮤니티',
        communityDesc: '커뮤니티에 대해 알아보고 전 세계 EcoFlow 사용자와 소통하세요!',

        successCopy: '클립보드에 성공적으로 복사되었습니다!',
        errorCopy: '클립보드에 복사할 수 없습니다!',

        chatTitle: '채팅하기',
        chatText: '약관 내용 로딩 실패하였습니다. 잠시 후에 다시 시도해 주세요.',
        chatDesc: '온라인 24 시간',
    },
    sa: {
        email: 'support.me@ecoflow.com',

        moduleTitle: 'تواصل معنا',
        phoneTitle: 'الخط الساخن لخدمة العملاء',
        emailText: 'راسِلنا عبر البريد الإلكتروني',
        communityTitle: 'مجتمع EcoFlow',
        communityDesc: 'اكتشف مجتمعنا وتواصل مع مستخدمي EcoFlow في جميع أنحاء العالم!',

        successCopy: 'تم النسخ إلى الحافظة بنجاح!',
        errorCopy: 'فشل النسخ إلى الحافظة!',
    },
    br: {
        moduleTitle: 'Entre em contato conosco',
        phoneTitle: 'Central de Atendimento ao Cliente',
        emailTitle: 'E-mail',
        emailText: 'Envie-nos um e-mail',
        email: 'support.br@ecoflow.com',
        communityTitle: 'Comunidade EcoFlow',
        communityDesc: 'Conheça nossa comunidade e conecte-se com usuários da EcoFlow em todo o mundo!',

        successCopy: 'Copiado com sucesso para a área de transferência!',
        errorCopy: 'Falha ao copiar para a área de transferência!',
    },
    mx: {
        email: 'support.eu@ecoflow.com ',

        moduleTitle: 'Contáctanos',
        phoneTitle: 'Línea de atención al cliente',
        emailText: 'Envíanos un correo electrónico',
        communityTitle: 'Comunidad de EcoFlow',
        communityDesc: '¡Descubre nuestra comunidad y conéctate con usuarios de EcoFlow de todo el mundo!',

        successCopy: '¡Copiado con éxito al portapapeles!',
        errorCopy: ' ¡No se pudo copiar al portapapeles!',
    },

    ph: {
        serviceTime: 'Monday to Friday, 09:00-18:00 (GMT+08:00)',
        email: 'support.sea@ecoflow.com',
        ...US_T,
    },

    nl: {
        phone: '800018036',
        serviceTime: 'Maandag t/m vrijdag van 9.00 tot 17.00 uur (CET)',
        email: 'support.eu@ecoflow.com',

        moduleTitle: 'Neem contact met ons op',
        phoneTitle: 'Klantenservice hulplijn',
        emailTitle: 'E-mail',
        emailText: 'Stuur ons een e-mail',
        communityTitle: 'EcoFlow-gemeenschap',
        communityDesc: 'Ontdek onze community en kom in contact met EcoFlow-gebruikers over de hele wereld!',

        successCopy: 'Succesvol naar het klembord gekopieerd!',
        errorCopy: 'Kopiëren naar het klembord is mislukt!',

        chatTitle: 'Vamos Conversar',
        chatText: 'Neem contact op via de Live Chat',
        chatDesc: 'Online 24 uur',
    },
};
